import { PrincipalType } from '@lucidlink/dto/validation';
import { encryptCryptoKeyWithPublicKey } from '@lucidlink/ts-crypto/crypto';
import { isNotNil } from '@lucidlink/tscore';
import { GroupManagementError } from './group-manager-errors';
export const prepareBulkAddGroupsMembershipsDto = async (params) => {
    const principalsCrypto = params.principalsCrypto;
    const uniqueMemberships = Array.from(new Map(params.memberships.map((membership) => [
        `${membership.groupId}-${membership.memberId}`,
        membership,
    ])).values());
    const allResult = await Promise.allSettled(uniqueMemberships.map((membership) => {
        return prepareSingleGroupMembership({
            principalsCrypto,
            ...membership,
        });
    }));
    allResult.forEach((result) => {
        if (result.status === 'rejected') {
            throw result.reason;
        }
    });
    // There are no rejected promises thanks to the upper forEach
    return allResult
        .map((result) => (result.status === 'rejected' ? null : result.value))
        .filter(isNotNil);
};
const prepareSingleGroupMembership = async (params) => {
    const { keys: groupKeys } = await params.principalsCrypto.verifyAndGetPrincipalKeys(params.groupId, {
        assertType: PrincipalType.GROUP,
    });
    if (!groupKeys) {
        throw new GroupManagementError('can not find group');
    }
    const { keys: memberKeys } = await params.principalsCrypto.verifyAndGetPrincipalKeys(params.memberId, {
        assertType: PrincipalType.MEMBER,
    });
    if (!memberKeys) {
        throw new GroupManagementError('can not find member');
    }
    return {
        groupId: params.groupId,
        memberId: params.memberId,
        eGroupPrivateKeyByMemberKey: await encryptCryptoKeyWithPublicKey(groupKeys.privateKey, memberKeys.publicKey),
    };
};
